import React, { Component } from 'react';
import { GoodsDtl } from './GoodsDtl';
import { GoodsList } from './GoodsList';
import { HeaderSub2 } from '../../Common/HeaderSub2'
import { HeaderSub } from '../../Common/HeaderSub'
import { GoodsZoom } from './GoodsZoom';
import { Footer } from '../../Common/Footer'
import { Big3Common } from '../../../js/IncludeManager'
/* 개발담당:양유빈
 * 화면기능:상품관리 마스터 페이지
 * 세부설명:
*/

export class Index extends Component {
    static displayName = Index.name;
    constructor(props) {
        super(props);
        this.state = {
            RenderName: this.CompName.GoodsList,  //기본 컴포넌트 할당
            ContentState: null
        };
    }
    //호출할 컴포넌트 이름
    CompName = {
        "GoodsList":"GoodsList",
        "GoodsDtl": "GoodsDtl",
        "GoodsReg": "GoodsReg",
        "GoodsZoom": "GoodsZoom"
    }
    //초기화
    componentDidMount() {
    }
    componentWillUnmount() {
        Big3Common.HistoryBackToClearBackdoor();
    }
    renderPick() {
        if (this.state.RenderName === this.CompName.GoodsDtl) {
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="제품상세"
                        ComponentUrl="GoodsList"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsDtl
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsList) {
            return (
                <div>
                    <HeaderSub2
                        HeaderTitle="나의 상품"
                        HistoryBack={true}
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsList
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                    <Footer
                        ComponentName={this.state.RenderName}
                    />
                </div>
            );
        }
        else if (this.state.RenderName === this.CompName.GoodsZoom) {
            //상품 Zoom 기능
            return (
                <div>
                    <HeaderSub
                        HeaderTitle="제품상세"
                        ComponentUrl="GoodsDtl"
                        RenderComponent={(RenderName) => this.setState({ RenderName: RenderName })}
                        ComponentName={this.state.RenderName}
                    />
                    <GoodsZoom
                        RenderComponent={(RenderName, ContentState) => this.setState({ RenderName: RenderName, ContentState: ContentState })}
                        ContentState={this.state.ContentState}
                    />
                </div>
            );
        }
    }  

    render() {        
        let RnderAct = this.renderPick();
        return (
            <div>
                {RnderAct}
            </div>
        );
    }
}
